import { Flex, Typography } from "djuno-design";
import Container from "../layouts/Container";
import SectionTitle from "./SectionTitle";
import AnimatedLinkBox from "./AnimatedLinkBox";

import productImage from "./../../assets/images/undraw_building_websites_i78t.svg";
import { AnimatedFadeInBox } from "./AnimatedFadeInBox";

const docsUrl = import.meta.env.VITE_DOCS_URL || "";

const productsItems = [
  {
    title: "AI-powered cloud cost optimization ",
    link: docsUrl + "/en/articles/12904364-ai-powered-cloud-cost-optimization",
  },
  {
    title: "Fully automated Complainace",
    link: docsUrl + "/en/articles/12904368-djuno-s-fully-automated-compliance",
  },
  {
    title: "Efficiency at scale",
    link: docsUrl + "/en/articles/12904370-efficiency-at-scale",
  },
  {
    title: "Resilience stack",
    link: docsUrl + "/en/articles/12904372-resilience-without-compromise",
  },
  {
    title: "Blockchain studio",
    link: docsUrl + "/en/articles/10436051-blockchain-studio",
  },
  {
    title: "dApp Studio",
    link: docsUrl + "/en/articles/10436045-dapp-studio",
  },
  {
    title: "Workflow studio",
    link: docsUrl + "/en/articles/10108417-workflow-studio",
  },
  {
    title: "Smart Web Apps",
    link: docsUrl + "/en/articles/10264660-web-apps",
  },
  {
    title: "Databases",
    link: docsUrl + "/en/articles/10108729-databases",
  },
  {
    title: "Fully managed RPC endpoints",
    link: docsUrl + "/en/articles/10108217-rpc-endpoints",
  },
  {
    title: "Managed compute instances",
    link: docsUrl + "/en/articles/10108734-instances",
  },
  {
    title: "Object storage",
    link: docsUrl + "/en/articles/10108413-object-storage",
  },
  {
    title: "Blockchain event streams",
    link: docsUrl + "/en/articles/10108385-block-events",
  },
  {
    title: "Fully managed IPFS nodes",
    link: docsUrl + "/en/articles/10108735-managed-ipfs",
  },
  {
    title: "Web3.0 Authentication APIs",
    link: docsUrl + "/en/articles/10108332-web3-0-auth-service",
  },
  {
    title: "Market Insight API",
    link: docsUrl + "/en/articles/10108725-market-insight-api",
  },
];

const ProductsBox = () => {
  return (
    <Container id="products">
      <div className="grid grid-cols-12 md:gap-8 mt-32">
        <div className="col-span-12 lg:col-span-8">
          <Flex direction="col" className="gap-4">
            <SectionTitle>
              <Typography.Text size="2xl" className="">
                Products & Services
              </Typography.Text>
            </SectionTitle>

            <Typography.Text
              size="base"
              uiType="secondary"
              className="tracking-wide"
            >
              Djuno offers a variety of products; the largest cloud offers
              search engine. Freely browse VM prices from 25+ providers, as well
              as enterprise grade decentralized storage compatible with S3 are
              some of them.
            </Typography.Text>

            <div className="grid grid-cols-12 gap-y-4 md:gap-4">
              {productsItems.map((item, index) => (
                <AnimatedLinkBox key={index} to={item.link} target="_blank">
                  <Typography.Text size="sm">{item.title}</Typography.Text>
                </AnimatedLinkBox>
              ))}
            </div>
          </Flex>
        </div>
        <div className="col-span-12 lg:col-span-4 self-center">
          <AnimatedFadeInBox>
            <img src={productImage} className="block mx-auto" alt="product" />
          </AnimatedFadeInBox>
        </div>
      </div>
    </Container>
  );
};

export default ProductsBox;
